import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as MessageFilledSvg } from './assets/message-filled.svg';

const MessageFilledIcon = React.forwardRef((args, ref) => <SvgIcon component={MessageFilledSvg} ref={ref} {...args} />);

export default MessageFilledIcon;
